import { emptyArr } from '@beef/utils';

import { AccumItemType } from 'types/accumulators';

export const filterNegativeAccumulators = (acc?: AccumItemType[]): AccumItemType[] => {
  if (!acc || !acc.length) return emptyArr;

  return acc.filter(({ rest, size }) => {
    let isRestNegative = false;
    let isSizeNegative = false;

    if (typeof rest === 'number') {
      isRestNegative = rest < 0;
    }

    if (typeof size === 'number') {
      isSizeNegative = size < 0;
    }

    return !isRestNegative && !isSizeNegative;
  });
};
